const sessionId = window.location.pathname.match(/\/(\d+)\//)[1]
export default sessionId
